import { Wrapper } from 'components'

export const AdminDashboard = () => {
  return (
    <div className="py-12">
      <Wrapper>
        <h1 className="pb-10 text-xxxl font-medium text-metal-900 flex items-center justify-between">
          Admin Dashboard
        </h1>
      </Wrapper>
    </div>
  )
}
